import React from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./CollectionCard.module.scss";
import { AppCollection } from "@/features/auth/types/auth";

interface CollectionCardProps {
  collection: AppCollection;
  isSelected: boolean;
  onSelect: (id: number) => void;
}

const CollectionCard = ({
  collection,
  isSelected,
  onSelect,
}: CollectionCardProps) => {
  const handleSelectClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onSelect(collection.id);
  };

  return (
    <Link
      to={`/saved-library/collections/${collection.id}/`}
      className={styles.cardContainer}
      style={{ cursor: "pointer" }}
    >
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <h3>{collection.name}</h3>
          <p>
            {collection.total_apps === 0
              ? `${collection.total_apps} Apps`
              : `${collection.total_apps > 1 ? `${collection.total_apps} Apps` : `${collection.total_apps} App`}`}
          </p>
        </div>
        <div className={styles.cardHeaderRight}>
          <button
            className={`${styles.selectButton} ${isSelected ? styles.selectButtonActive : ""}`}
            onClick={handleSelectClick}
          >
            {isSelected && (
              <img src="/img/whiteIcon/Check.svg" alt="checkCircleImg" />
            )}
          </button>
        </div>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.cardContentContainer}>
          {collection.total_apps > 0 ? (
            <>
              {collection.apps_last8.map((app, index) => (
                <img src={app.icon} alt={`App Icon ${app.name}`} key={index} />
              ))}
            </>
          ) : (
            <p className={styles.noApps}>No apps in this collection</p>
          )}
        </div>
      </div>
    </Link>
  );
};

export default CollectionCard;
